import React from 'react';
var useTabsStyles = () => {
  return React.useMemo(() => ({
    baseOnline: {
      width: 'fit-content',
      maxWidth: '100%'
    }
  }), []);
};
export default useTabsStyles;